import { useCallback, useMemo } from "react";
import Select, { ActionMeta, ValueType } from "react-select";
import { UPDATE_ENTITY_ACTIONS } from "../../../Common/constants";

type OptionType = { value: string; label: string };

interface Props {
  options: OptionType[];
  type?: string;
  disabled: boolean;
  updateFormValue: ({
    action,
    formValueProperties,
    value,
  }: {
    action: string;
    formValueProperties: string;
    value: string;
  }) => void;
}

export function StripeAccountTypeSelect({ options, type, disabled, updateFormValue }: Props) {
  const defaultValue = useMemo(() => options.find(it => it.value === type) ?? options[0], [
    options,
    type,
  ]);

  const handleChange = useCallback(
    (option: ValueType<OptionType, false>, _: ActionMeta<OptionType>) => {
      updateFormValue({
        action: UPDATE_ENTITY_ACTIONS.REPLACE,
        formValueProperties: "accountType",
        value: (option as OptionType).value,
      });
    },
    [updateFormValue]
  );

  return (
    <Select
      className="w-[300px]"
      defaultValue={defaultValue}
      options={options}
      isDisabled={disabled}
      onChange={handleChange}
    />
  );
}
